<script>

export default {
  name: "uConnectUserDetailsStep",
  data() {
    return {

    };
  },
  methods: {
    goNext() {
      this.$emit('stepChanged', 2);
      this.$router.push({name: 'uConnectSetPasswordStep'});
    },
  }
}
</script>

<template>
    <div class="setup-container">
      <el-row type="flex" justify="center" align="middle">
        <el-col :xs="24" :sm="20" :md="16" :lg="12" :xl="10">
          <el-card class="selection-card">
            <el-row :gutter="20">
              <div class="icons">
                <i class="el-icon-monitor"></i>
                <i class="laptop-icon"></i>
                <i   class="el-icon-mobile-phone"></i>

              </div>
            </el-row>
            <!-- Step Indicator Row -->
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <div class="step-indicator">
                  <div class="step-text">STEP 2 OF 3</div>
                </div>
              </el-col>
            </el-row>

            <!-- Title Row -->
            <el-row>
              <el-col :span="24">
                <h1 class="title">Finish setting up your account</h1>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <p class="description">
                  UNIFI is personalized for you.<br />
                  Create a password and start getting deals done!
                </p>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-button type="primary" class="next-button" @click="goNext">Next</el-button>
              </el-col>
            </el-row>
          </el-card>


<!--          <p class="step-text">STEP 2 OF 3</p>-->
<!--          <h2>Finish setting up your account</h2>-->
<!--          <p class="description">-->
<!--            UNIFI is personalized for you.<br />-->
<!--            Create a password and start getting deals done!-->
<!--          </p>-->

<!--          <el-button type="primary" class="next-button" @click="goNext">Next</el-button>-->
        </el-col>
      </el-row>
    </div>
</template>

<style scoped lang="css">
/* step2a */
.setup-container {
  padding: 20px;
  text-align: center;
}

.content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.icons {
  font-size: 40px;
  color: #333;
}

.step-text {
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-top: 10px;
}

h2 {
  font-size: 22px;
  font-weight: bold;
  margin-top: 10px;
}

.description {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.next-button {
  margin-top: 20px;
  background: #003333;
  color: #ffffff;
  border: none;
  width: 100%;
  padding: 12px;
  font-size: 16px;
}
/* step2b */
.setup-container {
  padding: 20px;
  text-align: center;
}

.content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.step-text {
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-bottom: 10px;
}

h2 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
}

.description {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}
/* tnc */


.tnc-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 90%;

}

.pdf-container {
  width: 100%;
  height: 30%;
  object-fit: contain;
}
.tnc-accept-checkbox {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #003333;
  border-color: #003333;
}
.tnc-accept-checkbox :hover {
  border-color: #003333 !important;
}
.tnc-accept-checkbox /deep/ .el-checkbox__label {
  color: #003333;
}
.tnc-accept-checkbox /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #003333 !important;
  border-color: #003333 !important;
}
.tnc-accept-checkbox /deep/ .el-checkbox__input.is-checked .el-checkbox__inner  {
  background-color: #003333 !important;
  border-color: #003333 !important;

}

.next-button.is-disabled {
  color: #FFF;
  background-color: rgba(0, 51, 51, 0.31);
  border-color: rgba(0, 51, 51, 0.31);
}
</style>


// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/userDetailsSteps/uConnectUserDetailsStep.vue